// extracted by mini-css-extract-plugin
export default {"updated":"Updated_updated__ZLfTy","mobile":"Updated_mobile__OC4qR","web":"Updated_web__9BYdR"};